export { default } from './PreferencesTabs';
export type { PreferencesTab } from './PreferencesTabs';
